var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-md-9",attrs:{"role":"main"}},[_vm._t("main")],2),_c('div',{staticClass:"col-md-3 sidebar",attrs:{"role":"complementary"}},[_c('div',{staticClass:"btn-group",attrs:{"role":"group","title":"Aktionen"}},[_vm._t("actions")],2),_c('div',{staticClass:"filter",attrs:{"title":"Filter"}},[_vm._t("filter")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }